// src/pages/NotFound/NotFound.style.js
import styled, {keyframes} from 'styled-components';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.5;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const gradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Main Wrapper
export const NotFoundWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  //background: linear-gradient(-45deg, #f7f7f7, #ffffff, #f0f9ff, #f7f7f7);
  background-size: 400% 400%;
  animation: ${gradient} 15s ease infinite;
  position: relative;
  overflow: hidden;
  padding: 20px;
	margin-top: 5rem;
	@media (max-width: 768px) {
    padding-top: 5rem;
    margin-top: 0;
  }		
`;

// Background Pattern
export const BackgroundPattern = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.03;
  //background-image: 
  //  repeating-linear-gradient(45deg, transparent, transparent 35px, #9cc54b 35px, #9cc54b 70px),
  //  repeating-linear-gradient(-45deg, transparent, transparent 35px, #9cc54b 35px, #9cc54b 70px);
`;

// Container
export const NotFoundContainer = styled.div`
    max-width: 1200px;
    width: 100%;
    //background: white;
    border-radius: 24px;
    padding: 60px 40px;
    //box-shadow: 
    //  0 20px 60px rgba(0, 0, 0, 0.08),
    //  0 0 0 1px rgba(0, 0, 0, 0.02);
    position: relative;
    z-index: 1;
    animation: ${fadeInUp} 0.6s ease;

    @media (max-width: 768px) {
        padding: 40px 24px;
        border-radius: 16px;
    }
`;

// Illustration Wrapper
export const IllustrationWrapper = styled.div`
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    height: 200px;
    margin-bottom: 30px;
  }
`;

// Animated Circles (Background)
export const AnimatedCircle = styled.div`
  position: absolute;
  width: ${props => props.delay === 0 ? '300px' : props.delay === 0.2 ? '240px' : '180px'};
  height: ${props => props.delay === 0 ? '300px' : props.delay === 0.2 ? '240px' : '180px'};
  border-radius: 50%;
  border: 2px solid ${props => props.delay === 0 ? '#9cc54b' : props.delay === 0.2 ? '#f01266' : '#00b4d8'};
  opacity: 0.1;
  animation: ${pulse} ${props => 2 + props.delay}s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;

  @media (max-width: 768px) {
    width: ${props => props.delay === 0 ? '220px' : props.delay === 0.2 ? '180px' : '140px'};
    height: ${props => props.delay === 0 ? '220px' : props.delay === 0.2 ? '180px' : '140px'};
  }
`;

// Error Code (404)
export const ErrorCode = styled.div`
    font-size: 140px;
    font-weight: 900;
    background: linear-gradient(135deg, #9cc54b 0%, #7ab535 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    position: relative;
    z-index: 2;
    animation: ${float} 3s ease-in-out infinite;
    text-shadow: 0 10px 30px rgba(156, 197, 75, 0.3);

    @media (max-width: 768px) {
        font-size: 100px;
    }

    @media (max-width: 480px) {
        font-size: 80px;
    }
`;

// Floating Elements (Emojis)
export const FloatingElement = styled.div`
  position: absolute;
  font-size: 48px;
  animation: ${float} ${props => 3 + props.delay}s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));

  &:nth-child(4) {
    top: 20%;
    left: 15%;
  }

  &:nth-child(5) {
    top: 30%;
    right: 15%;
  }

  &:nth-child(6) {
    bottom: 20%;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    font-size: 36px;

    &:nth-child(4) {
      left: 10%;
    }

    &:nth-child(5) {
      right: 10%;
    }
  }
`;

// Content Wrapper
export const ContentWrapper = styled.div`
  text-align: center;
  animation: ${fadeInUp} 0.6s ease 0.2s both;
`;

// Error Title
export const ErrorTitle = styled.h1`
  font-size: 42px;
  font-weight: 800;
  color: #0d1136;
  margin-bottom: 16px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

// Error Description
export const ErrorDescription = styled.p`
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 30px;
  }
`;

// Button Group
export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

// Primary Button
export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9cc54b 0%, #7ab535 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(156, 197, 75, 0.3);

  .icon {
    font-size: 20px;
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(156, 197, 75, 0.4);
    
    .icon {
      transform: scale(1.2);
    }
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
  }
`;

// Secondary Button
export const SecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: white;
  color: #0d1136;
  border: 2px solid #e6e6e6;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  .icon {
    font-size: 20px;
    transition: transform 0.3s ease;
  }

  &:hover {
    border-color: #9cc54b;
    color: #9cc54b;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    
    .icon {
      transform: scale(1.2);
    }
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
  }
`;